"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableCell = exports.TableRow = exports.TableBody = exports.TableHeader = exports.TableHead = exports.Table = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../../Constant");

var _Constant2 = require("../Constant");

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  padding-top: 28px;\n  padding-bottom: 28px;\n  font-size: 1.5rem;\n  font-weight: 500;\n  vertical-align: top;\n\n  &:first-child {\n    padding-left: 16px;\n  }\n\n  &:last-child {\n    padding-right: 16px;\n    text-align: right;\n  }\n\n  @media (min-width: ", "px) {\n    &:first-child {\n      padding-left: 28px;\n    }\n\n    &:last-child {\n      padding-right: 28px;\n    }\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n\n  &:nth-child(even) {\n    background-color: ", ";\n  }\n\n  &:nth-child(odd) {\n    background-color: ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  tr {\n    border-top: 1px solid ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  padding-bottom: 10px;\n  text-transform: uppercase;\n  text-align: left;\n  font-size: 1rem;\n  font-weight: 500;\n\n  &:first-child {\n    width: 154px;\n    padding-left: 16px;\n  }\n\n  &:last-child {\n    text-align: right;\n    padding-right: 28px;\n  }\n\n  @media (min-width: ", "px) {\n    &:first-child {\n      padding-left: 28px;\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  tr {\n    background-color: ", " !important;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  border-collapse: collapse;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Table = _styledComponents.default.table(_templateObject());

exports.Table = Table;

var TableHead = _styledComponents.default.thead(_templateObject2(), _Constant2.Color.WHITE);

exports.TableHead = TableHead;

var TableHeader = _styledComponents.default.th(_templateObject3(), _Constant.Width.SM);

exports.TableHeader = TableHeader;

var TableBody = _styledComponents.default.tbody(_templateObject4(), _Constant2.Color.GREY_3);

exports.TableBody = TableBody;

var TableRow = _styledComponents.default.tr(_templateObject5(), function (props) {
  return props.detailsAreOpen && 'height: 28.1rem;';
}, _Constant2.Color.GREY_1, _Constant2.Color.WHITE);

exports.TableRow = TableRow;

var TableCell = _styledComponents.default.td(_templateObject6(), _Constant.Width.SM);

exports.TableCell = TableCell;